<table class="table table-striped">
    <thead>
        <tr *ngIf="titulo" class="tr-cabezal">
            <th [colSpan]="tdExtra? columnas.length+1:columnas.length" > {{titulo}}  <span *ngIf='contador' class="th-contador">{{lista.length}}</span></th>
        </tr>
        <tr>
            <th [colSpan]="tdExtra? columnas.length+1:columnas.length" >
                <form class="table-form" [formGroup]="formularioBusqueda" (ngSubmit)="buscar()">
                    <input class="col-7 form-control" type="text" id="valor" formControlName="valor" (keyup)="buscar()" placeholder="Filtrar por...">
                    <select class="col-4 form-control" id="campo" formControlName="campo" (change)="buscar()">
                        <option *ngFor="let e of columnas; index as i" value="{{e}}">{{labels[i]}}</option>
                    </select>
                    <button class="col-1 form-control" (click)="reload()"><i class="bi bi-arrow-counterclockwise"></i></button>
                </form>
            </th>
        </tr>
        <tr>
            <th *ngFor="let l of labels" >{{l.toLocaleUpperCase()}}</th>
            <th *ngIf="tdExtra && tdExtra.th" class="btn-td" (click)="all()"><i *ngIf="checkeable && tdExtra.all" class="bi bi-record-circle"></i><i *ngIf="!checkeable || !tdExtra.all" class="{{tdExtra.th}}"></i></th>
            <th *ngIf="tdExtra && !tdExtra.th"></th>
        </tr>
    </thead>
    <tbody *ngIf="resultados.length>0 else notFound">
        <tr *ngFor="let tupla of resultados" (click)="select(selectable? tupla: null)" ngClass="{{ disabled && tupla[disabled]? 'disabled': selectable==true? 'selectable':''}}"  >
            <td *ngFor="let c of columnas">
                <ngb-highlight highlightClass="resaltado" [result]="tupla[c]" [term]="formularioBusqueda.value.valor"></ngb-highlight>
            </td>
            <td *ngIf="tdExtra && tdExtra.td && (!disabled || !tupla[disabled])" class="btn-td" (click)="put(tupla)"><i *ngIf="checkeable && tupla.check" class="bi bi-record-circle"></i><i *ngIf="!checkeable || !tupla.check" class="{{tdExtra.td}}"></i>
            <td *ngIf="tdExtra && (!tdExtra.td || (disabled && tupla[disabled]))"></td>
        </tr>
    </tbody>
    <ng-template #notFound>
        <tbody>
            <tr>
                <td [colSpan]="tdExtra? columnas.length+1:columnas.length" >
                    No se encontraron coincidencias para su búsqueda
                </td>
            </tr>
        </tbody>
    </ng-template>
</table>
